const skeletonPalette = (tokens) => {
    return {
        background: tokens.skeletonColorBg,
        border: {
            default: tokens.skeletonColorBorder,
            width: tokens.skeletonBorderWidthNone,
            radius: {
                round: tokens.skeletonRadiusRound,
                sharp: tokens.skeletonRadiusSharp
            }
        }
    };
};
export default skeletonPalette;
//# sourceMappingURL=skeleton.js.map